import React from 'react';
import ReactDOM from 'react-dom';

// Shared styled replacement for window.confirm() — a native confirm()
// renders as unstyled browser chrome ("localhost:3000 says..."), which
// looks broken next to the rest of the app. Portal-rendered to document.body
// so it floats above whatever scroll container/overflow context it's
// opened from, matching the pattern this app already used in a couple of
// places (GearCard.js/ItemDetail.js's own delete confirmations) before this
// was pulled out into one shared component.
const ConfirmDialog = ({
  message,
  confirmLabel = 'Confirm',
  workingLabel = 'Working...',
  cancelLabel = 'Cancel',
  working = false,
  danger = true,
  onCancel,
  onConfirm,
}) => {
  return ReactDOM.createPortal(
    <div style={{
      position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
      backgroundColor: 'rgba(44,48,48,0.55)', zIndex: 9999,
      display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '24px'
    }}>
      <div style={{
        backgroundColor: '#ffffff', borderRadius: '20px', padding: '28px 24px',
        width: '100%', maxWidth: '300px', display: 'flex', flexDirection: 'column',
        gap: '20px', boxShadow: '0 8px 32px rgba(44,48,48,0.18)'
      }}>
        <p style={{
          fontFamily: 'Poppins, Arial, sans-serif', fontSize: '15px',
          color: '#2c3030', textAlign: 'center', lineHeight: '1.5', margin: 0
        }}>{message}</p>
        <div style={{ display: 'flex', gap: '10px' }}>
          <button onClick={onCancel} disabled={working} style={{
            flex: 1, height: '48px', borderRadius: '99px', backgroundColor: '#f5f7f7',
            border: '1px solid #e0e1e1', fontFamily: 'Poppins, Arial, sans-serif',
            fontSize: '14px', fontWeight: 600, color: '#565959', cursor: 'pointer'
          }}>{cancelLabel}</button>
          <button onClick={onConfirm} disabled={working} style={{
            flex: 1, height: '48px', borderRadius: '99px',
            backgroundColor: danger ? '#fc4b4e' : 'var(--brand-primary, #2be494)',
            border: 'none', fontFamily: 'Poppins, Arial, sans-serif',
            fontSize: '14px', fontWeight: 600, color: danger ? '#ffffff' : '#2c3030',
            cursor: 'pointer', opacity: working ? 0.6 : 1
          }}>{working ? workingLabel : confirmLabel}</button>
        </div>
      </div>
    </div>,
    document.body
  );
};

export default ConfirmDialog;
